export const WORKSPACE_ROLES = {
  ADMIN: 'ADMIN',
  MEMBER: 'MEMBER',
};

export const INVITABLE_ROLES = [WORKSPACE_ROLES.ADMIN, WORKSPACE_ROLES.MEMBER];

export function roleLabel(role) {
  if (role === WORKSPACE_ROLES.ADMIN) return 'Admin';
  return 'Member';
}

/**
 * Missing workspaceRole = Admin so existing accounts keep settings access.
 */
export function normalizeWorkspaceRole(role) {
  if (role === WORKSPACE_ROLES.MEMBER) return WORKSPACE_ROLES.MEMBER;
  return WORKSPACE_ROLES.ADMIN;
}

export function isAdmin(userOrRole) {
  if (!userOrRole) return false;
  const role =
    typeof userOrRole === 'string'
      ? userOrRole
      : userOrRole.workspaceRole || userOrRole.role;
  return normalizeWorkspaceRole(role) === WORKSPACE_ROLES.ADMIN;
}

export const ADMIN_SETTINGS_TABS = ['team', 'products', 'billing'];
